<div class="w-full mx-auto p-5 space-y-6">

  <!-- Header y botón nuevo -->
  <div class="flex flex-wrap justify-between items-center gap-4">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Relay de Webhooks Wompi</h1>
      <p class="text-gray-500 mt-1">Configura URLs para retransmitir webhooks de Wompi automáticamente</p>
    </div>
    <a routerLink="/dashboard/config/wompi-relay/new"
       class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition flex items-center gap-2">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Nueva URL de Relay
    </a>
  </div>

  <!-- Filtro búsqueda -->
  <div class="relative w-full md:w-1/2">
    <input type="text"
           [(ngModel)]="searchTerm"
           (input)="applyFilters()"
           placeholder="Buscar por nombre, URL o descripción..."
           class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
    <svg class="w-5 h-5 absolute left-3 top-2.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
    </svg>
  </div>

  <!-- Tabla -->
  <div class="rounded-xl border border-gray-200 shadow-sm overflow-x-auto">
    <table class="w-full">
      <thead class="bg-gray-50">
      <tr>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Nombre</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">URL Destino</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Estado</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Headers</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Auditoría</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Acciones</th>
      </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
      <tr *ngFor="let url of filteredRelayUrls" class="hover:bg-gray-50 transition">
        <td class="px-4 py-3">
          <div class="text-sm font-medium text-gray-800">{{ url.name }}</div>
          <div *ngIf="url.description" class="text-xs text-gray-500 mt-1">{{ url.description }}</div>
        </td>
        <td class="px-4 py-3">
          <div class="text-sm text-blue-600 truncate max-w-xs" [title]="url.targetUrl">
            {{ url.targetUrl }}
          </div>
        </td>
        <td class="px-4 py-3">
          <span class="px-3 py-1 text-xs font-medium rounded-full cursor-pointer"
                [ngClass]="{
                  'bg-green-100 text-green-800': url.isActive,
                  'bg-gray-100 text-gray-800': !url.isActive
                }"
                (click)="toggleActivation(url)">
            {{ url.isActive ? 'Activo' : 'Inactivo' }}
          </span>
        </td>
        <td class="px-4 py-3">
          <span class="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
            {{ url.activeHeadersCount }} header(s)
          </span>
        </td>
        
        <!-- Audit Info -->
        <td class="px-4 py-3">
          <app-audit-info 
            [auditData]="getAuditData(url)"
            layout="horizontal"
            size="sm">
          </app-audit-info>
        </td>
        
        <td class="px-4 py-3">
          <div class="flex items-center gap-2">
            <!-- Ver Logs -->
            <button (click)="viewLogs(url)"
                    class="text-purple-600 hover:text-purple-800 p-2 rounded-md hover:bg-purple-50"
                    title="Ver Logs">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </button>
            
            <!-- Editar -->
            <button (click)="editUrl(url)"
                    class="text-blue-600 hover:text-blue-800 p-2 rounded-md hover:bg-blue-50"
                    title="Editar">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
            </button>
            
            <!-- Eliminar -->
            <button (click)="confirmDelete(url)"
                    class="text-red-600 hover:text-red-800 p-2 rounded-md hover:bg-red-50"
                    title="Eliminar">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            </button>
          </div>
        </td>
      </tr>
      <tr *ngIf="filteredRelayUrls.length === 0">
        <td colspan="6" class="px-4 py-8 text-center text-gray-500">
          No se encontraron URLs de relay
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Modal de confirmación de eliminación -->
<div *ngIf="showDeleteConfirm" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
    <h3 class="text-lg font-semibold text-gray-900 mb-4">Confirmar Eliminación</h3>
    <p class="text-gray-600 mb-6">
      ¿Está seguro de que desea eliminar la URL de relay "<strong>{{ urlToDelete?.name }}</strong>"?
      Esta acción no se puede deshacer.
    </p>
    <div class="flex justify-end gap-3">
      <button (click)="cancelDelete()"
              class="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition">
        Cancelar
      </button>
      <button (click)="deleteUrl()"
              class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition">
        Eliminar
      </button>
    </div>
  </div>
</div>

